import { render } from "./InterconsultaOrigenForm.vue?vue&type=template&id=41f05f98&scoped=true"
import script from "./InterconsultaOrigenForm.vue?vue&type=script&lang=js"
export * from "./InterconsultaOrigenForm.vue?vue&type=script&lang=js"

import "./InterconsultaOrigenForm.vue?vue&type=style&index=0&id=41f05f98&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f05f98"]])

export default __exports__